export default __webpack_public_path__ + "static/do-support-copy-97c73231e0a34c199c658678d6d61367.png";